import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import logo from './assets/Logo.svg'; // Adjust the path based on your folder structure

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleMenuToggle = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        if (window.innerWidth < 768) {
            setIsMobileMenuOpen(false);
        }
    };

    return (
        <nav className="navbar">
            <div className="navbar-logo">
                <img src={logo} alt="ELF Logo" className="logo-image" />
            </div>
            <div 
                className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`} 
                onClick={handleMenuToggle}
            >
                <span></span>
                <span></span>
                <span></span>
            </div>
            <ul className="navbar-links">
                <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
                <li><Link to="/team" onClick={closeMobileMenu}>Echipa</Link></li>
                <li><Link to="/events" onClick={closeMobileMenu}>Evenimente</Link></li>
                <li><Link to="/contact" onClick={closeMobileMenu}>Contact</Link></li>
            </ul>

            {/* Mobile Menu */}
            <ul className={`navbar-links-mobile ${isMobileMenuOpen ? 'active' : ''}`}>
                <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
                <li><Link to="/team" onClick={closeMobileMenu}>Echipa</Link></li>
                <li><Link to="/events" onClick={closeMobileMenu}>Evenimente</Link></li>
                <li><Link to="/contact" onClick={closeMobileMenu}>Contact</Link></li>
            </ul>
        </nav>
    );
};

export default Navbar;
